import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { OIDCAuthGuard as authGuard } from '@core/auth/oidc-auth-guard';
import { environment } from '@env/environment';

import { DashboardComponent } from '@modules/general/dashboard/dashboard.component';
import { PageNotFoundComponent } from '@modules/general/page-not-found/pagenotfound.component';
import { TeamListComponent } from '@modules/team/components/team-list/team-list.component';
import { GeneralModule } from '@modules/general/general.module';
import { TeamModule } from '@modules/team/team.module';
import { HocModule } from '@hoc/hoc.module';
import { HocAccessDeniedComponent } from '@hoc/hoc-access-denied/hoc-access-denied.component';
import { CustomerListComponent } from '@modules/customer/components/customer-list/customer-list.component';
import { ProjectListComponent } from '@modules/project/project-list/project-list.component';
import { SkillListComponent } from '@modules/skill/skill-list/skill-list.component';
import { UsefulLinksComponent } from '@modules/useful/useful-links/useful-links.component';
import { OverviewListComponent } from '@modules/overview/overview-list/overview-list.component';

const routes: Routes = [
  { path: 'access-denied', component: HocAccessDeniedComponent },
  {
    path: '',
    component: DashboardComponent,
    data: { roles: [environment.roles.superUser, environment.roles.user] },
    runGuardsAndResolvers: 'always',
    canActivate: [authGuard],
    canActivateChild: [authGuard]
  },
  { path: 'dashboard', redirectTo: '' },
  {
    path: 'team',
    component: TeamListComponent,
    data: { roles: [environment.roles.superUser, environment.roles.user] },
    runGuardsAndResolvers: 'always',
    canActivate: [authGuard],
    canActivateChild: [authGuard]
  },
  {
    path: 'customer',
    component: CustomerListComponent,
    data: { roles: [environment.roles.superUser, environment.roles.user] },
    runGuardsAndResolvers: 'always',
    canActivate: [authGuard],
    canActivateChild: [authGuard]
  },
  {
    path: 'useful',
    component: UsefulLinksComponent,
    data: { roles: [environment.roles.superUser, environment.roles.user] },
    runGuardsAndResolvers: 'always',
    canActivate: [authGuard],
    canActivateChild: [authGuard]
  },
  {
    path: 'projects',
    component: ProjectListComponent,
    data: { roles: [environment.roles.superUser, environment.roles.user] },
    runGuardsAndResolvers: 'always',
    canActivate: [authGuard],
    canActivateChild: [authGuard]
  },
  {
    path: 'skills',
    component: SkillListComponent,
    data: { roles: [environment.roles.superUser, environment.roles.user] },
    runGuardsAndResolvers: 'always',
    canActivate: [authGuard],
    canActivateChild: [authGuard]
  },
  {
    path: 'overview',
    component: OverviewListComponent,
    data: { roles: [environment.roles.superUser, environment.roles.user] },
    runGuardsAndResolvers: 'always',
    canActivate: [authGuard],
    canActivateChild: [authGuard]
  },
  { path: '**', component: PageNotFoundComponent }
];


  // { path: 'employees/employee', component: EmployeeComponent },
  // { path: 'skills', component: SkillsComponent },
  // {
  //   path: 'help',
  //   component: HelpComponent,
  //   data: { roles: [environment.roles.superUser, environment.roles.user] },
  //   runGuardsAndResolvers: 'always',
  //   canActivate: [MsalGuard],
  //   canActivateChild: [MsalGuard]
  // },


@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      anchorScrolling: 'enabled'
    }),
    GeneralModule,
    TeamModule,
    HocModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  exports: [RouterModule]
})
export class AppRoutingModule {}
